export default "__VITE_ASSET__DCxC4EtW__"